import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import "./aboutStory.css";
import storyItems from "./AboutStoryItems";

const AboutStory = () => {
  const hiddenElementsRef = useRef([]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("shown");
        } else {
          entry.target.classList.remove("shown");
        }
      });
    });

    hiddenElementsRef.current.forEach((el) => {
      observer.observe(el);
    });
    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Történetünk | Bálint Analitika Laboratórium | Budapest XI. kerület
        </title>
        <meta
          name="description"
          content="Ismerje meg a Bálint Analitika Orvosdiagnosztikai Laboratórium történetét. 2007-es alapításunk óta a megbízható laborvizsgálatok és kiváló minőség elkötelezettjei vagyunk Budapesten."
        />
        <meta
          name="keywords"
          content="Bálint Analitika történet, orvosi laboratórium története, laborvizsgálatok Budapest, XI. kerület laboratórium"
        />
        <link
          rel="canonical"
          href="https://balintanalitika.hu/orvosdiagnosztika/rolunk/tortenetunk"
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalBusiness",
            name: "Bálint Analitika Orvosdiagnosztikai Laboratórium",
            url: "https://balintanalitika.hu",
            logo: "https://balintanalitika.hu/assets/medical/logo/logo.png",
            description:
              "A 2007-ben alapított Bálint Analitika Laboratórium megbízható orvosdiagnosztikai vizsgálatokat végez Budapest XI. kerületében.",
            foundingDate: "2007-06-01",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Kondorfa utca 6.",
              addressLocality: "Budapest",
              postalCode: "1116",
              addressRegion: "XI. kerület",
              addressCountry: "HU",
            },
          })}
        </script>
      </Helmet>
      <main className="navbar-margin">
        <div className="container">
          <header>
            <h1 className="heading-primary">Történetünk</h1>
            <p className="about-story-intro">
              A Bálint Analitika Orvosdiagnosztikai Laboratórium több mint 15
              éves történetét a szakmai kiválóság és a megbízhatóság jellemzi
              Budapest XI. kerületében.
            </p>
          </header>

          <section className="about-grid grid--2-cols grid--center-v">
            {storyItems.map((item, index) => (
              <React.Fragment key={item.id}>
                {index % 2 === 0 ? (
                  <>
                    <div
                      className="about-story-item-pic-box hidden"
                      ref={(el) => hiddenElementsRef.current.push(el)}
                      key={`pic-${item.id}`}
                    >
                      <img
                        src={process.env.PUBLIC_URL + item.pictureSrc}
                        alt={`Bálint Analitika laboratórium - ${item.title}`}
                        className="about-story-item-pic"
                        width="400"
                        height="300"
                        loading={index > 0 ? "lazy" : "eager"}
                      />
                    </div>
                    <article
                      className="about-story-item-box hidden"
                      ref={(el) => hiddenElementsRef.current.push(el)}
                    >
                      <h2 className="about-heading-tertiary">{item.title}</h2>
                      <p className="about-story-item-text">{item.content}</p>
                    </article>
                  </>
                ) : (
                  <>
                    <article
                      className="about-story-item-box hidden"
                      ref={(el) => hiddenElementsRef.current.push(el)}
                    >
                      <h2 className="about-heading-tertiary">{item.title}</h2>
                      <p className="about-story-item-text">{item.content}</p>
                    </article>
                    <div
                      className="about-story-item-pic-box hidden"
                      ref={(el) => hiddenElementsRef.current.push(el)}
                      key={`pic-${item.id}`}
                    >
                      <img
                        src={process.env.PUBLIC_URL + item.pictureSrc}
                        alt={`Bálint Analitika laboratórium - ${item.title}`}
                        className="about-story-item-pic"
                        width="400"
                        height="300"
                        loading="lazy"
                      />
                    </div>
                  </>
                )}
              </React.Fragment>
            ))}
          </section>
        </div>

        <section className="container conclusion-section">
          <p
            className="about-ending-text hidden"
            ref={(el) => hiddenElementsRef.current.push(el)}
          >
            <strong>
              Üdvözöljük Önt a Bálint Analitika Orvosdiagnosztikai
              Laboratóriumának világában, ahol az egészségügy és a minőség
              szolgálatában állunk Budapest XI. kerületében.
            </strong>
          </p>
          <p
            className="about-ending-text about-ending-text-last hidden"
            ref={(el) => hiddenElementsRef.current.push(el)}
          >
            <strong>Ismerje meg...</strong>
          </p>
          <div
            className="button-container hidden"
            ref={(el) => hiddenElementsRef.current.push(el)}
          >
            <a
              href="/orvosdiagnosztika/rolunk/csapatunk"
              className="btn btn-lg about-button about-button-team"
              title="Ismerje meg a Bálint Analitika csapatát"
            >
              Vezetőségünket
            </a>
            <a
              href="/orvosdiagnosztika/vizsgalatok"
              className="btn btn-lg about-button about-button-team"
              title="Tekintse meg laboratóriumi vizsgálatainkat"
            >
              Vizsgálataink
            </a>
          </div>
        </section>
      </main>
    </>
  );
};

export default AboutStory;
